var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsThumbsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9987 13.9993H4.66536V5.33268L9.33203 0.666016L10.1654 1.49935C10.2431 1.57713 10.307 1.68268 10.357 1.81602C10.407 1.94935 10.432 2.07713 10.432 2.19935V2.43268L9.6987 5.33268H13.9987C14.3543 5.33268 14.6654 5.46602 14.932 5.73268C15.1987 5.99935 15.332 6.31046 15.332 6.66602V7.99935C15.332 8.07713 15.3209 8.16046 15.2987 8.24935C15.2765 8.33824 15.2543 8.42157 15.232 8.49935L13.232 13.1993C13.132 13.4216 12.9654 13.6105 12.732 13.766C12.4987 13.9216 12.2543 13.9993 11.9987 13.9993ZM5.9987 12.666H11.9987L13.9987 7.99935V6.66602H7.9987L8.8987 2.99935L5.9987 5.89935V12.666ZM4.66536 5.33268V6.66602H2.66536V12.666H4.66536V13.9993H1.33203V5.33268H4.66536Z",
    fill: "#586C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsThumbsUp);
export default __webpack_public_path__ + "static/media/icons_thumbs_up.c70718f1.svg";
export { ForwardRef as ReactComponent };